module.exports = __webpack_public_path__ + "assets/img/b53dfd34f2f681399022d63248e93268.png";